import { Box } from "@chakra-ui/react";
import { SelectBox } from "@/Components/SelectBox/select-box.";

import { Item, SelectedItems } from "@/types/productTypes";
import { LearnMore } from "../../learnMore/learn-more.component";
import useBreakpoint from "@/hooks/use-breakpoint";
import { useTranslation } from "@/hooks/use-translation";

type RadioButtonItemProps = {
   item: Item;
   index: number;
   controlValue: SelectedItems;
   radio?: any;
};

export default function RadioButtonItem({
   item,
   index,
   controlValue,
   radio,
}: RadioButtonItemProps) {
   const { isMobile } = useBreakpoint();
   const { translate, isIcelandic, translation } = useTranslation();
   if (!controlValue) {
      controlValue = {
         selected: false,
         selectedItem: "-1",
      };
   }
   console.log("isIcelandic", isIcelandic);
   console.log("item", item);
   return (
      <Box key={`boxroom-${index}`}>
         <SelectBox
            name={radio.name}
            value={radio.value}
            isDisabled={item.disabled}
            isChecked={
               controlValue.selected &&
               controlValue.selectedItem === item.id?.toString()
            }
            onChange={radio.onChange}
         >
            <Box as="span" className="text-body-l-paragraph text-dark">
               {translate(item)}
            </Box>
         </SelectBox>

         {item.notice && (
            <div
               style={{
                  padding: "2px 6px",
                  color: "#666",
                  fontSize: isMobile ? "12px" : "14px",
                  display: "flex",
                  gap: "4px",
               }}
            >
               *{" "}
               <span>
                  {item.notice === "custom price upon request"
                     ? translation.notices.customPrice
                     : item.notice}
               </span>
            </div>
         )}

         {item.learnMoreId && <LearnMore learnMoreId={item.learnMoreId} />}
      </Box>
   );
}
